/* Copyright 2024 City Trax Limited. All rights reserved. */

import {
    ContentLayout,
    Header,
} from '@cloudscape-design/components';
import { Outlet } from "react-router-dom";

function TextTuner() {
    // TODO update from 'correction' to 'review' or 'checker'
    return (
        <ContentLayout
            header={
                <Header variant="h1" description="Unify your content">
                    Text Tuner
                </Header>
            }
        >

            <Outlet />
        </ContentLayout>

    )

}

export default TextTuner;